import { render, staticRenderFns } from "./rewardRules.vue?vue&type=template&id=6c965a3c"
import script from "./rewardRules.vue?vue&type=script&lang=js"
export * from "./rewardRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports